// extracted by mini-css-extract-plugin
export default {"getOffer2":"GetOffer2_getOffer2__u5bKy","header":"GetOffer2_header__A6IVd"};